const d365formblockjs = {
    formId: null,
    redirectURL: null,
    disableRecaptcha: null,
    formName: null,
    formType: null,
    preventDefault: true,
    Init: function (formId, redirectURL, disableRecaptcha, formName, formType) {
        this.formId = formId;
        this.redirectURL = redirectURL;
        this.disableRecaptcha = disableRecaptcha;
        this.formName = formName;
        this.formType = formType;
        if (this.disableRecaptcha && this.disableRecaptcha === "false") {
            this.LoadGoogleReCaptcha();

            document.addEventListener("d365mkt-formsubmit", async function (event) {
                if (d365formblockjs.preventDefault) {
                    event.preventDefault();
                } else {
                    return;
                }

                if (recaptchavalidation) {
                    var isValid = await recaptchavalidation.IsValid();
                    if (isValid) {
                        d365formblockjs.SubmitD365Form();
                    }
                } else {
                    d365formblockjs.SubmitD365Form();
                }
            });
        }

        document.addEventListener("d365mkt-afterformsubmit", function (event) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'D365FormSubmit',
                'formName': d365formblockjs.formName,
                'formType': d365formblockjs.formType
            });
            if (d365formblockjs.redirectURL && d365formblockjs.redirectURL.trim() !== "") {
                location.href = d365formblockjs.redirectURL;
            }
            else {
                d365formblockjs.ShowD365VideoBlock();
            }
        });
        
        document.querySelectorAll('[id^="video-"]').forEach(button => {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                window.location.hash = this.id;

                if (this.id) {
                    var visibleBlock = document.querySelector('div[id^="d365-video-block-"].d-block');
                    if (visibleBlock) {
                        visibleBlock.classList.replace("d-block", "hidden");
                    }

                    var videoNumber = this.id.slice(-1);
                    var d365videoblockSelected = document.getElementById("d365-video-block-" + videoNumber);
                    if (d365videoblockSelected) {
                        d365videoblockSelected.classList.replace("hidden", "d-block");
                    }
                }
            });
        });
    },
    LoadGoogleReCaptcha: async function () {
        var src = "/dist/js/RecaptchaValidationScripts.min.js";
        var script = document.createElement("script");
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.setAttribute("src", src);
        document.querySelector("body").appendChild(script);
    },
    SubmitD365Form: function () {
        this.preventDefault = false;
        const formDiv = document.querySelector('div[data-form-id="' + this.formId + '"]');
        if (!formDiv) {
            console.error('Div with Form not found');
            return;
        }

        const form = formDiv.querySelector('form.marketingForm');
        if (!form) {
            console.error('Form element not found');
            return;
        }

        var submitBtn = form.querySelector(".submitButton");
        if (submitBtn) {
            if (submitBtn.type === "submit") {
                setTimeout(() => {
                    submitBtn.click();
                }, 200);
            } else {
                console.error("The button is not a submit button.");
            }
        }
    },
    ShowD365VideoBlock: function () {
        var d365videoblock = document.getElementById("d365-video-block");
        if (d365videoblock) {
            d365videoblock.classList.replace("hidden", "d-block");

            var d365videoblock1 = document.getElementById("d365-video-block-1");
            if (d365videoblock1) {
                d365videoblock1.classList.replace("hidden", "d-block");
            }

            const hasBlocksClass = d365videoblock.parentElement.classList.contains('blocks');
            const hasPibClass = d365videoblock.parentElement.classList.contains('pib');

            if (!hasBlocksClass && !hasPibClass) {
                const parentDiv = d365videoblock.parentElement.parentElement.parentElement.parentElement;
                parentDiv.append(d365videoblock);
            }
        }
    }
};

window.d365formblockjs = d365formblockjs;